module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    on: {
      "submit": _vm.createConversation
    }
  }, [_c('div', {
    staticClass: "col-md-5 "
  }, [_c('h5', [_vm._v("Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    ref: "name",
    attrs: {
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.conversation.title),
      callback: function($$v) {
        _vm.$set(_vm.conversation, "title", $$v)
      },
      expression: "conversation.title"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Members")]), _vm._v(" "), _c('p', [_vm._v("* These mobile devices, intercoms, and users are allowed to send messages in this conversation.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "Members",
      "multiple": "",
      "options": _vm.allWireUsers,
      "label": "name",
      "name": "members",
      "value": _vm.conversation.members
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.conversation, "members", $event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f06adf0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/wire/CreateConversation.vue
// module id = 652
// module chunks = 1